module.exports = __webpack_public_path__ + "img/hyperlink.d6765674.svg";